module.exports = __webpack_public_path__ + "img/frame_hover.145053dc.png";